import React from "react";
import { CheckCircle2, Phone, Mail, RotateCcw } from "lucide-react";

export const ThankYou = ({ submission, onRestart }) => {
  const rec = submission?.recommendation;
  return (
    <section
      className="max-w-3xl mx-auto px-4 sm:px-6 py-14 sm:py-20 rc-fade-up"
      data-testid="thank-you-section"
    >
      <div className="bg-white border border-slate-200 rounded-3xl shadow-xl shadow-[#63499d]/10 p-8 sm:p-12 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-[#ecac1f] text-[#2a1f4a] grid place-items-center mb-5">
          <CheckCircle2 className="w-9 h-9" />
        </div>
        <h2
          className="font-display text-3xl sm:text-4xl text-[#2a1f4a] leading-tight"
          data-testid="thank-you-title"
        >
          You're all set, {submission?.contact?.name?.split(" ")[0] || "friend"}.
        </h2>
        <p className="text-base text-slate-500 mt-3 max-w-xl mx-auto leading-relaxed">
          Your request has been received. A Ricochet fuel specialist will reach
          out shortly with a tailored quote
          {rec?.primary?.name && (
            <>
              {" "}for{" "}
              <span className="font-semibold text-[#63499d]">{rec.primary.name}</span>
              {rec?.is_hybrid && (
                <>
                  {" "}+{" "}
                  <span className="font-semibold text-[#63499d]">{rec.alternate.name}</span>
                </>
              )}
            </>
          )}
          .
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-md mx-auto">
          <a
            href="tel:+18339255065"
            className="btn-ghost inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold"
            data-testid="thank-you-call-button"
          >
            <Phone className="w-4 h-4" />
            833-925-5065
          </a>
          <a
            href="mailto:sales@ricochetfuel.com?subject=Fuel%20Survey%20Follow-up"
            className="btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-bold"
            data-testid="thank-you-email-button"
          >
            <Mail className="w-4 h-4" />
            Email Sales
          </a>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-100">
          <button
            type="button"
            onClick={onRestart}
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#63499d] hover:text-[#4d3884] transition-colors"
            data-testid="thank-you-restart-button"
          >
            <RotateCcw className="w-4 h-4" />
            Take the survey again
          </button>
        </div>
      </div>
    </section>
  );
};

export default ThankYou;
